/**
 * Constantes para validação de upload de arquivos
 */

// Limite máximo de tamanho de arquivo: 500KB
export const MAX_FILE_SIZE_KB = 500;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_KB * 1024;
export const MAX_FILE_SIZE_MB = MAX_FILE_SIZE_KB / 1024; // ~0.488 MB

/**
 * Valida se o arquivo não excede o tamanho máximo (500KB)
 */
export const isValidFileSize = (file: File): boolean => {
  return file.size <= MAX_FILE_SIZE_BYTES;
};

/**
 * Retorna mensagem de erro formatada para arquivo muito grande
 */
export const getFileSizeErrorMessage = (): string => {
  return `Arquivo muito grande. Máximo: ${MAX_FILE_SIZE_KB}KB (${MAX_FILE_SIZE_MB.toFixed(2)}MB)`;
};

/**
 * Formata o tamanho do arquivo para exibição
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};




